import React from 'react';
import "./index.css"

const About =  () => {
    return (
        <div className="aboutPage">
            <h1>About Us</h1>
            <div className="aboutMainSection">
                <p>NTR’s Peer Feedback for Negotiation website automates what some of us have been doing manually: preparing individual feedback reports for students based on their peer feedback.</p>
                <p>Here is how the product works: the instructor sets up a class by uploading a list of exercises or cases for which students are to provide peer feedback. The students will be able to enroll in the class and receive survey links. The survey feedback questions are pre-populated, but instructors can swap out a standard question for one of their own. The instructor can grade the feedback behind the scenes for quality. When ready to send reports, the instructor selects which exercises or cases should be in the report and hits send.</p>
                <p>The product aggregates all of an individual student’s feedback to generate a student mean and standard deviation for each question. The product also aggregates across the class, so that each student can compare his or her averages to the class average. Open-ended feedback is provided verbatim.</p>
                <h2>Team</h2>
                <div className="photos">
                    <div className="photo">
                        <img src={require("../../Images/jeanne.JPG")} alt="Jeanne Brett"/>
                        <div className="caption">
                            <h3>Jeanne Brett</h3>
                            <h4>President</h4>
                        </div>
                    </div>
                    <div className="photo">
                        <img src={require("../../Images/holly.JPG")} alt="Holly Schroth"/>
                        <div className="caption">
                            <h3>Holly Schroth</h3>
                            <h4>Director</h4>
                        </div>
                    </div>
                    <div className="photo">
                        <img src={require("../../Images/stephen.JPG")} alt="Stephen Golgberg"/>
                        <div className="caption">
                            <h3>Stephen Golgberg</h3>
                            <h4>Director</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;
